import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./styles/changePassword.scss";
import axios from "axios";
import RightIcon from "./rightIcon.svg";
import { Collapse } from "@material-ui/core";

export default function ChangePassword() {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [msg, setMsg] = React.useState(null);
  const [showButton, setShowButton] = React.useState(true);
  const emailInputRef = React.useRef();

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendResetLink = () => {
    setMsg(null);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/users/api/v1/reset-password-link`,
        { email }
      )
      .then((res) => {
        //console.log(res.data);
        setShowButton(false);
        setMsg(res.data.message);
      })
      .catch((err) => {
        setMsg(err.response.data.message);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && validateEmail(email) && showButton) {
      e.preventDefault();
      sendResetLink();
    }
  };

  return (
    <div className="change-pass-container">
      <div onClick={handleClickOpen} className="link-button">
        Forgot password?
        <img src={RightIcon} />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Forgot password?"}</DialogTitle>
        <DialogContent>
          <p className="header-title-change-password">
            {" "}
            Please enter the mail address you have been registered with. A reset
            link will be sent there
          </p>

          <Collapse in={msg ? true : false}>
            <h3 className="success-message-change-password">{msg}</h3>
          </Collapse>
          <div className="change-pass-group">
            <input
              ref={emailInputRef}
              value={email}
              onChange={(e) => {
                e.preventDefault();
                setEmail(e.target.value);
              }}
              onKeyDown={handleKeyDown}
              type="text"
              disabled={!showButton ? true : false}
            />
          </div>
        </DialogContent>
        {showButton && (
          <DialogActions>
            <button
              className="change-pass-button"
              onClick={sendResetLink}
              color="primary"
              autoFocus
              disabled={!validateEmail(email)}
            >
              Send reset link
            </button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
